export default {
  openNewMarketsInMinutes: {
    id: 'merchant_options_markets_open_new_markets_in_minutes',
    defaultMessage:
      'Open new markets to reach more customers in few minutes...',
  },
  moreMarketsMoreMoneyTitle: {
    id: 'merchant_options_markets_more_markets_more_money_title',
    defaultMessage: 'More markets, more money...',
  },
  moreMarketsMoreMoneyText: {
    id: 'merchant_options_markets_more_markets_more_money_text',
    defaultMessage:
      'In one click, you automatically get a delivery label directly linked to your order and a schedule for pick up by the carrier at your warehouse/store.',
  },
  easyProcessTitle: {
    id: 'merchant_options_markets_easy_process_title',
    defaultMessage: 'Easy process',
  },
  easyProcessText: {
    id: 'merchant_options_markets_easy_process_text',
    defaultMessage:
      'In one click, you automatically get a delivery label directly linked to your order and a schedule for pick up by the carrier at your warehouse/store.',
  },
  automaticRulesTitle: {
    id: 'merchant_options_markets_automatic_rules_title',
    defaultMessage: 'Automatic rules',
  },
  automaticRulesText: {
    id: 'merchant_options_markets_automatic_rules_text',
    defaultMessage:
      'In one click, you automatically get a delivery label directly linked to your order and a schedule for pick up by the carrier at your warehouse/store.',
  },
  whatsNext: {
    id: 'merchant_options_markets_whats_next',
    defaultMessage: 'What’s next?',
  },
  diversificationTitle: {
    id: 'merchant_options_markets_diversification_title',
    defaultMessage: 'Diversification',
  },
  diversificationText: {
    id: 'merchant_options_markets_diversification_text',
    defaultMessage:
      'You can expand your activity by selling new product categories on BackMarket. XXX, XXX and XXX are three trendings categories on BackMarket right now.',
  },
  waitingNewMarketsTitle: {
    id: 'merchant_options_markets_waiting_new_markets_title',
    defaultMessage: 'Waiting for new markets',
  },
  waitingNewMarketsText: {
    id: 'merchant_options_markets_waiting_new_markets_text',
    defaultMessage:
      'BackMarket is always working to improve its reach by opening new market all around the world. We will let you know as soon as new markets are available for you.',
  },
  optimizeWithBackMarketServicesTitle: {
    id: 'merchant_options_markets_optimize_with_backMarket_services_title',
    defaultMessage: 'Optimize your processes with BackMarket’s services',
  },
  optimizeWithBackMarketServicesText: {
    id: 'merchant_options_markets_optimize_with_backMarket_services_text',
    defaultMessage:
      'Optimize your activity on BackMarket by suscribing to one of our services. BackCare, BackShip, BackRepair, BackParts, etc... Learn more about our services.',
  },
  openNewMarket: {
    id: 'bo_seller.options.markets.open_new_market',
    defaultMessage:
      'Please contact your Seller Success Manager or check the Seller Support Center for information on how to open new markets.',
  },
}
